/**
 * Pełne okno wizualizacji (OW) ma dwa wejścia: konkretne posiedzenie (/PublicSession/:code) i stały link
 * jednostki (/Visualization/:code). Oba dzielą język, wyniki głosowań i style - także selektory CSS klientów.
 */
export const PUBLIC_SESSION_ROUTE_NAME = "PublicSession";
export const VISUALIZATION_ROUTE_NAME = "Visualization";

const FULL_OW_ROUTE_NAMES = [PUBLIC_SESSION_ROUTE_NAME, VISUALIZATION_ROUTE_NAME];

export function isFullOwRouteName(routeName) {
    return FULL_OW_ROUTE_NAMES.includes(routeName);
}

/**
 * Wersja dla kodu, który działa przed rozwiązaniem trasy (np. wybór języka przy starcie aplikacji).
 */
export function isFullOwUrl(url) {
    return FULL_OW_ROUTE_NAMES.some(routeName => url.includes(`/${routeName}/`));
}

/*
 * Stały link okna wizualizacji ma postać /Visualization/{id jednostki}/{adres}. Identyfikator jednostki jest
 * stałym członem - zapewnia unikalność linku i na nim opiera się limiter zapytań po stronie serwera.
 * Poniższe reguły dotyczą tylko drugiego członu, który ustala klient; sprawdza je także serwer
 * (VisualizationLinkSlugRules w eSesja.Core), więc zmiana tutaj wymaga zmiany tam. Ograniczenia i wzorzec
 * przychodzą razem ze stanem z api/management/settings/visualization-link, więc panel nie musi ich powtarzać;
 * stałe poniżej są wartościami zapasowymi na czas ładowania.
 */
export const VISUALIZATION_SLUG_MIN_LENGTH = 3;
export const VISUALIZATION_SLUG_MAX_LENGTH = 40;
export const VISUALIZATION_SLUG_PATTERN = "^[a-z][a-z0-9-]*[a-z0-9]$";

/**
 * Adres w postaci, w jakiej trafia na serwer: bez białych znaków na brzegach, małymi literami.
 */
export function normalizeVisualizationSlug(slug) {
    return (slug || "").trim().toLowerCase();
}

export function isVisualizationCodeWellFormed(code, pattern = VISUALIZATION_SLUG_PATTERN) {
    const value = normalizeVisualizationSlug(code);

    if (value.length < VISUALIZATION_SLUG_MIN_LENGTH || value.length > VISUALIZATION_SLUG_MAX_LENGTH) {
        return false;
    }

    return new RegExp(pattern).test(value) && !value.includes("--");
}

/*
 * Serwer zwraca powód odrzucenia jako nazwę wartości enuma (VisualizationLinkSlugError), a panel pokazuje
 * komunikat z tłumaczeń - stąd zamiana PascalCase na kebab-case, tak samo jak dla rodzajów zdarzeń historii
 * (VisualizationActivityEvent).
 */
export function toTranslationKeySuffix(enumName) {
    return (enumName || "")
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .toLowerCase();
}
